import { Trans } from '@lingui/macro';
import { MenuItem, MenuList } from '@pocketlaw/tetris';
export function NoColumns() {
    return (<MenuList>
      <MenuItem disabled>
        <Trans comment="Sortable columns menu: No columns message">No columns</Trans>
      </MenuItem>
    </MenuList>);
}
